"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blankFormTriggerTemplate = void 0;
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: `Untitled`,
    contentType: 'html',
    contentData: [
        {
            type: 'form-submit-button',
            version: '1',
            id: 'cfd4f7f2-3c18-4d75-b8fe-2d6cd197a3b3',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#1515FF',
                borderRadius: 4,
                buttonColor: '#1515FF',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 200,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [],
};
const blankFormTriggerTemplate = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            version: '1.0.2',
            variables: {
                input: [],
                output: [],
            },
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
            type: 'start',
            next: null,
        },
    ];
});
exports.blankFormTriggerTemplate = blankFormTriggerTemplate;
//# sourceMappingURL=blankFormTrigger.js.map